jQuery(document).ready(function($) {
    let isProductHit = false;

    let category_id = active_category_id != null ? active_category_id : $('#active_category').data('value');
    let variation_id = 0;
    let next_page = 1;
    var refresh = true;

    let url = $("#saleGetProducts").val();
    getProductAjax(next_page);
    let nextUrl = null;

    //Category Filter
    $('.categoryFilter').on('click', function() {
        category_id = $(this).data('id');
        next_page = 1;
        //  console.log(category_id);
        $('.widget-filter-reset').removeClass('active-filter');
        $('.categoryFilter').removeClass('active-filter');
        $(this).addClass('active-filter');
        refresh = true;
        getProductAjax(next_page);
    });

    $('.widget-filter-reset.categories-filter').on('click', function() {
        category_id = $('#active_category').data('value');
        getProductAjax(next_page);
        $('.categoryFilter').removeClass('active-filter');
    });

    // $(document).on('click', '.loadmore', function() {
    //     refresh = false;
    //     url = $(this).data('url');
    //     getProductAjax();
    // });

    $(window).scroll(function() {
        if (!isProductHit && ($(window).scrollTop() + $(window).height() >= $(document).height() - 1000)) {
            refresh = false;
            next_page++;
            if (nextUrl !== null) {
                getProductAjax(next_page);
            }
        }
    });

    //Products through AJAX..
    function getProductAjax(next_page) {
        isProductHit = true;

        if (refresh) {
            $('#shop-1').html("");
        } else {
            $('.loadmore').attr('hidden', true);
        }
        $('.loader').addClass('skeleton-loader');

        let filUrl = $("#fileURL").val();;
        axios
            .get(url + "?page=" + next_page, {
                params: {
                    category_id: category_id,
                    sales_id: $("#salesID").val(),
                }
            })
            .then(function(response) {
                nextUrl = response.data.next_page_url;

                // console.log(response.data.current_page);
                if (response.data.data.length > 0) {
                    // console.log('111111111111', response);
                    var next_page_url = response.data.next_page_url;
                    response.data.data.forEach(element => {
                        let detailUrl = $("#detailURL").val();
                        // detailUrl = detailUrl.replace(':slug', element.category[0].slug);
                        detailUrl = detailUrl.replace(':productname', slugify(`${element.name} ${element.code}`, { lower: true }));
                        // console.log(element);

                        let delTag = "";
                        if (element.discount > 0) {

                            delTag = `<del>${element.discount.pivot.amount}</del>`;

                        } else {

                            delTag = `<del></del>`;
                        }

                        let sale = '';
                        if (element.is_variant_price) {

                            var variant_price = {};
                            var variantID = 0;

                            element.product_variants.forEach(function(e) {
                                if (e.price > 0) {
                                    variant_price[e.id] = e.price;
                                }
                            });

                            var minvarPrice = Number.POSITIVE_INFINITY;

                            $.each(variant_price, function(index, value) {
                                if (minvarPrice > value) {
                                    minvarPrice = value;
                                    variantID = index;
                                }
                            });

                            var variant_discount = 0;
                            element.product_variants.forEach(function(e) {
                                if (variantID == e.id) {
                                    variant_discount = e.discount_price;
                                }
                            });
                        }
                        let price = `<div> ${element.price.toLocaleString('en-US', { style: 'currency', currency: 'PKR', })}</div>`;

                        if (element.is_variant_price) {
                            if (variant_discount > 0) {
                                price = `<del>PKR ${(parseInt(minvarPrice)).toFixed(0).toLocaleString()}</del> <ins> PKR ${variant_discount}</ins> `;
                            } else if (element.discount) {
                                if (element.discount.type == 3) {
                                    sale = `<div class="sale-flash badge bg-danger p-2">SALE</div>`
                                } else {
                                    if (element.discount.show_cut_price == 0) {
                                        sale =
                                            `<div class="sale-flash badge bg-danger p-2">${element.discount.name}!</div>`
                                    } else if (element.discount.show_cut_price == 1) {
                                        sale =
                                            `<div class="sale-flash badge bg-danger p-2">${element.discount.pivot.amount}% OFF</div>`
                                    }
                                }
                                if (element.discount.show_cut_price == 1) {

                                    price = `<del>PKR ${(parseInt(minvarPrice)).toFixed(0).toLocaleString()}</del>
                                      <ins> PKR ${(minvarPrice - (minvarPrice / 100) * element.discount.pivot.amount).toFixed(0).toLocaleString()}</ins>
                                          `;
                                } else {
                                    price =
                                        `<div> PKR ${(minvarPrice - (minvarPrice / 100) * element.discount.pivot.amount).toFixed(0).toLocaleString()}</div>`;
                                }
                            } else {
                                price = `<div> PKR ${minvarPrice}</div>`;
                            }
                        } else {
                            if (element.discount) {
                                if (element.discount.type == 3) {
                                    sale = `<div class="sale-flash badge bg-danger p-2">SALE</div>`
                                } else {
                                    if (element.discount.show_cut_price == 0) {
                                        sale = `<div class="sale-flash badge bg-danger p-2">${element.discount.name}!</div>`;
                                    } else if (element.discount.show_cut_price == 1) {
                                        sale = `<div class="sale-flash badge bg-danger p-2">${element.discount.pivot.amount}% OFF</div>`;
                                    }
                                }
                                if (element.discount.show_cut_price == 1) {
                                    price = `<del>PKR ${(parseInt(element.price)).toFixed(0).toLocaleString()}</del> <ins> PKR ${(element.price - (element.price / 100) * element.discount.pivot.amount).toFixed(0).toLocaleString()}</ins>`;
                                } else {
                                    price = `<div> PKR ${(element.price - (element.price / 100) * element.discount.pivot.amount).toFixed(0).toLocaleString()}</div>`;
                                }
                            } else {
                                price = `<div> PKR ${element.price}</div>`;
                            }
                        }
                        //         let price =
                        //             `<div> ${element.price.toLocaleString('en-US', { style: 'currency', currency: 'PKR', })}</div>`;
                        //         if (element.discount) {
                        //             if (element.discount.type == 3) {
                        //                 sale = `<div class="sale-flash badge bg-danger p-2">SALE</div>`
                        //             } else {
                        //                 if (element.discount.show_cut_price == 0) {
                        //                     sale = `<div class="sale-flash badge bg-danger p-2">${element.discount.name}!</div>`
                        //                 } else if (element.discount.show_cut_price == 1) {
                        //                     sale = `<div class="sale-flash badge bg-danger p-2">${element.discount.pivot.amount}% OFF</div>`
                        //                 }
                        //             }
                        //             if (element.discount.show_cut_price == 1) {
                        //                 price = `<del>PKR ${(parseInt(element.price)).toFixed(0).toLocaleString()}</del>
                        //   <ins> PKR ${(element.price - (element.price / 100) * element.discount.pivot.amount).toFixed(0).toLocaleString()}</ins>
                        // `
                        //             } else {
                        //                 price =
                        //                     `<div> PKR ${(element.price - (element.price / 100) * element.discount.pivot.amount).toFixed(0).toLocaleString()}</div>`;
                        //             }
                        //         }

                        let images = "";
                        let colors = "";

                        for (i = 0; i < element.variation_gallery.length; i++) {
                            images += `
                <div class="oc-item">
                    <a href="${detailUrl}"><img src="${filUrl}${element.variation_gallery[i].featured_image}" alt="${element.code} ${element.variation_gallery[i].variation_detail.name} ${i}"></a>
                </div>
                `
                            colors += `
                  <button role="radio" class="owl-dot active" data-value="${element.variation_gallery[i].variations_detail_id}" data-color="${element.variation_gallery[i].variation_detail.color_code}"></button>
                      `
                        }

                        let col = "";
                        let saleType = $("#saleType").val();
                        if (saleType == 1) {
                            col = "col-md-4";
                        } else {
                            col = "col-md-3";
                        }

                        $('#shop-1').append(`
              <div class="${col} col-6">
                <div class="product-image">
                  <div id="oc-products" class="owl-carousel image-carousel carousel-widget custom-js">
                      ${images}
                  </div>
                  ${sale}
                  <div class="text-center mb-3">
                      <div class="product-desc text-center pb-0">
                        <div class="product-title"><h4 class="text-uppercase mb-0"><a href="${detailUrl}">${element.name} ${element.code}</h4></a>

                        </div>

                        <div class="product-price font-primary">
                            <h4 class="mb-0">${price}</h4>
                        </div>
                      </div>
                      <div class="owl-dots">
                          ${colors}
                      </div>
                  </div>
                </div>
              </div>
            `);
                    })

                } else {
                    $('#shop-1').append(`
            <div class="product col-md-12">
                <div class="grid-inner">
                    <div class="product-desc">
                        <div class="product-title text-center"><h3>No products were found matching your selection.</h3></div>
                    </div>
                </div>
            </div>
          `);
                }

                $(".product-image").each(function() {
                    let colorValue = $(this).find('.product-color-value'),
                        productDots = $(this).find('.owl-dots'),
                        currentOwl = $(this).find('.owl-dot.active').attr("data-value");

                    colorValue.text(currentOwl);

                    let owl = $(this).find('.owl-carousel').owlCarousel({
                        items: 1,
                        dotsContainer: productDots,
                        autoplay: true,
                        autoplayTimeout: 4000,
                        loop: true,
                        autoplayHoverPause: true,
                    });

                    productDots.find('button').each(function() {
                        let dot = $(this),
                            color = dot.attr('data-color');

                        dot.css({ 'background-color': color });
                    });
                })

                $('.loader').removeClass('skeleton-loader');
                isProductHit = false;

                // if (next_page_url) {
                //     // if (next_page_url != null) {
                //     //     url = next_page_url;
                //     // } else {
                //     //     url = null;
                //     // }
                // }

            })
            .catch(function(error) {
                console.log(error);
            })


    }
});